export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_18.68f3ea77.png";